export default __webpack_public_path__ + "empty-cart.30b4d5a2.png";